<div
  class="tw-w-full tw-h-full tw-bg-cover tw-bg-center"
  [style.background-image]="code | toTuiCountryIsoCode | tuiFlag | imageUrl:'wo-common/assets/logo/iss.png'"
></div>
